import React from 'react';
import { Box, Button, Paper } from '@mui/material';
import JsonView from 'react18-json-view';

const DetailPanelJsonView = ({ src, collapsed, onCollapseAll, onExpandAll }) => {
  return (
    <Paper
      sx={{
        p: 2,
        height: '100%',
        overflow: 'auto',
        bgcolor: '#0b1e33',
        borderColor: 'rgba(0, 229, 255, 0.35)',
        color: '#e1f6ff',
      }}
      variant="outlined"
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 1 }}>
        <Button size="small" variant="outlined" onClick={onCollapseAll}>
          Collapse All
        </Button>
        <Button size="small" variant="outlined" onClick={onExpandAll}>
          Expand All
        </Button>
      </Box>
      <JsonView
        src={src}
        collapsed={collapsed ? true : false}
        enableClipboard
        displayDataTypes={false}
        displayObjectSize={false}
        theme="winter-is-coming"
        style={{
          backgroundColor: 'transparent',
          color: 'inherit',
        }}
      />
    </Paper>
  );
};

export default DetailPanelJsonView;

